import {
  styled,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemIconProps
} from '@mui/material'

export const BotaoItem = styled(ListItemButton)<ListItemButtonProps>(
  ({ theme }) => ({
    height: '48px',
    color: theme.palette.text.secondary,
    borderLeft: `solid 2px ${theme.palette.background.primary}`,
    span: {
      ...theme.typography.body1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      borderLeft: `solid 2px ${theme.palette.primary.light}`
    },
    '&.Mui-selected': {
      span: { ...theme.typography.body1Bold },
      backgroundColor: theme.palette.background.primary,
      borderLeft: `solid 2px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      svg: {
        color: theme.palette.primary.main
      },
      img: {
        filter:
          'brightness(0) saturate(100%) invert(38%) sepia(94%) saturate(3173%) hue-rotate(153deg) brightness(88%) contrast(103%)'
      }
    }
  })
)

export const IconeItem = styled(ListItemIcon)<ListItemIconProps>(() => ({
  minWidth: '2.5em'
}))
